import App from './App';
import React from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import { BrowserRouter, hashHistory } from 'react-router';
import { Provider as Redux } from 'react-redux';

const muiTheme = getMuiTheme({
  palette: {
    primary1Color: '#00e39a',
    primary2Color: '#00e39a',
  },
});

const Root = ({ store }) => (
  <Redux store={store}>
    <BrowserRouter history={hashHistory}>
      <MuiThemeProvider muiTheme={muiTheme}>
        <App />
      </MuiThemeProvider>
    </BrowserRouter>
  </Redux>
);

Root.propTypes = {
  store: React.PropTypes.object,
};

export default Root;



// WEBPACK FOOTER //
// ./src/browser/app/Root.js